<button
  class="toggle-button {{ buttonType }}"
  [ngClass]="{ deactivated: !activated, activated: activated }"
  [disabled]="disabled"
  (click)="toggle()"
>
  <span class="toggle-content">
    <i *ngIf="activated" class="fas fa-check"></i>
    <i *ngIf="!activated" class="fas fa-times"></i>
    <span>{{ caption }}</span>
  </span>
</button>
